import { Error } from "@baseline/common";
import { Context } from "./context";
import { Handler } from "./handler";
import { RoutePath, RoutePathArgumentTypes } from "./route-path";


export interface Route
{
    path?: RoutePath;
    test?: PredicateFunction;
    endPoint?: boolean;
    handlers: Handler[];
}

export namespace Route
{
    export function build(specs: RouteSpecs): Route;
    export function build({ predicate, handlers }: RouteSpecs): Route
    {
        const { path: predicatePath, args, ...properties } = predicate;

        let path: RoutePath;
        try
        {
            path =
                (predicatePath) &&
                (
                    predicatePath instanceof RoutePath
                        ? predicatePath
                        : RoutePath.build(predicatePath, args)
                );
        }
        catch (error)
        {
            const path =
                (predicatePath instanceof RoutePath)
                    ? predicatePath.path
                    : predicatePath;
            throw new Error(`Unable to build route with path ${path}.`, error);
        }

        return (
            {
                ...(path && { path }),
                ...properties,
                handlers,
            }
        );
    }
}


export type PredicateFunction<C extends Context = Context> = (context: C) => boolean | Promise<boolean>;


export interface RoutePredicate<T extends RoutePathArgumentTypes = RoutePathArgumentTypes>
{
    path?: string | RoutePath;
    test?: PredicateFunction;
    args?: T;
    endPoint?: boolean;
};


export interface RouteSpecs
{
    predicate: RoutePredicate;
    handlers: Handler[];
}
